import { useSpring } from '@react-spring/web'
import { useEffect } from 'react'

export function useAnimatedValue(value: number) {
  const [spring, api] = useSpring(
    () => ({
      number: 0,
    }),
    []
  )

  useEffect(() => {
    if (typeof window !== 'undefined') {
      api.start({ number: value })
    }
  }, [value, api])

  return spring.number
}
